import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { ProposalComponent } from './component/proposal/proposal.component';
import { LoginComponent } from './component/login/login.component';
import { OpenspaceComponent } from './component/openspace/openspace.component';
import { MsalGuard } from '@azure/msal-angular';
import { AgendaComponent } from './component/agenda/agenda.component';
import { ReportComponent } from './component/report/report.component';
import { ReportSurveyComponent } from './component/report-survey/report-survey.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'proposal', component: ProposalComponent, canActivate: [ MsalGuard ] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [ MsalGuard ] },
  { path: 'dashboard/:id', component: DashboardComponent, canActivate: [ MsalGuard ] },
  { path: 'openspace', component: OpenspaceComponent, canActivate: [ MsalGuard ] },
  { path: 'agenda', component: AgendaComponent, canActivate: [ MsalGuard ] },
  { path: 'reports', component: ReportComponent, canActivate: [ MsalGuard ] },
  { path: 'survey', component: ReportSurveyComponent, canActivate: [ MsalGuard ] },
  { path: '**', redirectTo: '/login'},
  { path: '', redirectTo: '/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, onSameUrlNavigation: "reload" })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
